// extracted by mini-css-extract-plugin
export default {"blockHalf":"halfInfoBlock_blockHalf__lLWy-","description":"halfInfoBlock_description__EjT+v","data":"halfInfoBlock_data__O7DdZ"};